<template>
	<div :class="['managing-box', { 'managing-box--x-scroll': xScroll }]">
		<header v-if="title" class="box__header">
			<span
				v-html="title"
				:class="[
					'box__header__title',
					{
						'box__header__title--required': isRequired,
					},
				]"
			/>
		</header>
		<div
			:class="[
				'box__conts',
				contsClass,
				{
					'box__conts--no-padding': noPadding,
					'box__conts--block': isBlockBox,
					'box__conts--horizontal': horizontalMode,
				},
			]"
			:style="{
				padding: contsPadding,
				height: contsHeight,
			}"
		>
			<slot />
		</div>
	</div>
</template>
<script>
	export default {
		name: 'ManagingBox',
		props: {
			title: {
				type: String,
				default: '',
			},
			isRequired: {
				type: Boolean,
				default: false,
			},
			isBlockBox: {
				type: Boolean,
				default: false,
			},
			horizontalMode: {
				type: Boolean,
				default: false,
			},
			noPadding: {
				type: Boolean,
				default: false,
			},
			xScroll: {
				type: Boolean,
				default: false,
			},
			contsPadding: {
				type: String,
				default: '6px',
			},
			contsHeight: {
				type: String,
				default: '',
			},
			contsClass: {
				type: String,
				default: '',
			},
		},
	};
</script>
<style lang="scss" scoped>
	.managing-box {
		display: flex;
		flex-flow: row nowrap;
		justify-content: flex-start;
		align-items: stretch;
		width: 100%;
		border: solid 1px #dfe6ee;
		border-top: none;

		@media (max-width: 768px) {
			display: block;
		}

		&--x-scroll {
			overflow: hidden;

			.box__conts {
				overflow-x: auto;
			}
		}
	}

	.box__header {
		position: relative;
		flex: 0 0 auto;
		padding: 18px 0 18px 32px;
		border-right: solid 1px #dfe6ee;
		background: linear-gradient(to right, #dfe6ee, #f4f7fa, #f4f7fa);

		@media (max-width: 768px) {
			display: block;
			width: 100% !important;
			background: #dfe6ee;
			padding: 10px 0 10px 32px;
		}
	}

	.box__header__title {
		color: #657088;
		font-weight: bold;
		line-height: 13px;
	}

	.box__header__title--required {
		position: relative;
		display: inline;

		&:after {
			content: '필수';
			display: block;
			position: absolute;
			top: 0;
			left: 100%;
			height: 14px;
			padding: 0 3px;
			line-height: 14px;
			margin-left: 4px;
			background-color: #e31b1b;
			border-radius: 2px;
			text-align: center;
			color: #fff;
			font-size: 0.75rem;
			font-weight: normal;
			white-space: nowrap;
		}
	}

	.box__conts {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: column;
		flex: 1 1 100%;
		width: 100%;
		background: white;
		padding: 6px 30px;
		vertical-align: top;
		word-break: break-word;

		@media (max-width: 768px) {
			display: block;
		}
	}

	.box__conts--block {
		display: block;
	}

	.box__conts--horizontal {
		align-items: center;
		justify-content: flex-start;
		flex-direction: row;
	}

	.box__conts--no-padding {
		padding: 0;
	}
</style>
